<template>
  <v-container>
    <component  :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage":"https://hot-linux.dev/flow",
        "headline":"Hot Linux ／ WEBシステム開発（ご相談から納品まで）",
        "description":"Hot Linux では、概ねこの様な流れで開発を進めます。クライアント様としっかりお打ち合わせを繰り返しながら進めています。",
        "image":[
          "https://hot-linux.dev/img/hot-linux-logos_purple.de39c269.webp"
        ],
        "author":{
          "@type":"Person",
          "name":"山田昌史",
          "url":"https://hot-linux.dev/"
        }
      }
    </component>
    <v-row>
      <v-col cols="12" md="6">
        <left-side>
        </left-side>
      </v-col>
      <v-col cols="12" md="6">
        <v-breadcrumbs
          icon="mdi-truck-check-outline"
          bg-color="grey-lighten-4"
          rounded
        >
          <h3>ご相談から納品まで</h3>
        </v-breadcrumbs>
        <v-card  class='mx-3 my-3'>
          <v-card-title>
            1.ご相談
          </v-card-title>
          <v-card-text>
            まずはご相談ください。詳細な画面レイアウトや設計書等は必要ありません。具体的な形はお打ち合わせの中で決定していきます。<br>完成までいくつかお手伝い頂きたい事がありますのでよろしくお願いいたします。
          </v-card-text>
        </v-card>
        <v-card  class='mx-3 my-3'>
          <v-card-title>
            2.お見積り
          </v-card-title>
          <v-card-text>
            やりたいことや必要な機能をお打ち合わせをして、大まかにまとめた内容で工数を算出しお見積りを出します。<br>
            ご要望のシステムが運用できるだけの最低ラインの内容で金額をご提示します。<br>
            この辺りで運用するサーバーも決めていきます。
          </v-card-text>
        </v-card>
        <v-card  class='mx-3 my-3'>
          <v-card-title>
            3.開発
          </v-card-title>
          <v-card-text>
            お打ち合わせの内容に合わせて、開発をしていきます。最初は大まかな形で進めてお互いの認識にズレがないか確認しながら開発します。
          </v-card-text>
        </v-card>
        <v-card  class='mx-3 my-3'>
          <v-card-title>
            4.動作確認
          </v-card-title>
          <v-card-text>
            お打ち合わせ（ご要望）の内容にあっているか、不具合はないか等、お互いに逐次動作を確認して進められれば思います。<br>
            お手数をおかけしますが、よろしくお願いいたします。
          </v-card-text>
        </v-card>
        <v-card  class='mx-3 my-3'>
          <v-card-title>
            5.システム面から見直しと運用自体の見直し
          </v-card-title>
          <v-card-text>
            画面を見てから思いつくことや方法転換したい内容を含め、開発中に詳細なお打ち合わせをします。システムに追加のご要望を頂いたり、社内業務の運用方法自体の見直しをして頂きながら改修します。
          </v-card-text>
        </v-card>
        <v-card  class='mx-3 my-3'>
          <v-card-title>
            6.3〜5を繰り返し
          </v-card-title>
          <v-card-text>
            開発中にお打ち合わせや方向修正をしながら完成を目指します。<br>修正内容がお見積り時の工数を超える場合は追加のお費用をお願いすることがございます。よろしくお願いいたします。
          </v-card-text>
        </v-card>
        <v-card  class='mx-3 my-3'>
          <v-card-title>
            7.テスト運用
          </v-card-title>
          <v-card-text>
            ある程度開発が進んだところで、ご依頼者様のサーバーにセットアップしますので1週間程度のテスト運用をお願いいたします。
          </v-card-text>
        </v-card>
        <v-card  class='mx-3 my-3'>
          <v-card-title>
            8.納品完了です。
          </v-card-title>
          <v-card-text>
            納品完了です。納品完了後もHot Linuxで不具合と判断できるものであれば対応いたします。
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LeftSide from './LeftSide.vue'
export default {
  components: {LeftSide },
  data(){
    return {
      流れrtn:[],
    }
  },
}
</script>
